import '@babel/polyfill';

import { login, logout, signup } from './login';

import { updateSettings } from './updateSettings';

import { ratingForm } from './ratings'


import { showAlert } from './alerts';

import { searchGame } from './search';

import { currentFeedback } from './feedback';





/// get rid of null in console by checking if there is a login form

const loginForm = document.querySelector('.form__login--form');

const logOutBtn = document.getElementById('logout');

const updateDataForm = document.querySelector('.user__form--data');

const updatePasswordForm = document.querySelector('.user__form--password');

const signupForm = document.querySelector('.form__signup--form');

const searchFormSubmit = document.querySelector('.header__center--form');

const genreFormSubmit = document.querySelector('.myGenres__form');






/// Search Bar

searchFormSubmit.addEventListener('submit', (e) => {

	e.preventDefault();

	const search = document.getElementById('searchBar').value.trim();

	searchGame(search);

})




/// slider values

const sliders = document.querySelectorAll('.rating--slider');

sliders.forEach(slider => {

	const valueDisplay = document.getElementById(`${slider.id}-value`);

	valueDisplay.textContent = slider.value;

	slider.addEventListener('input', () => {

		valueDisplay.textContent = slider.value;
	});
});




/// signup function


if (signupForm) {

	signupForm.addEventListener('submit', event => {

		event.preventDefault();

		const name = document.getElementById('new-name').value;
		const email = document.getElementById('new-email').value;
		const password = document.getElementById('new-password').value;
		const passwordConfirm = document.getElementById('new-passwordConfirm').value;

		signup(name, email, password, passwordConfirm)

	})
}

/// login function


if (loginForm) {

	loginForm.addEventListener('submit', event => {

		event.preventDefault();

		const email = document.getElementById('email').value;
		const password = document.getElementById('password').value;

		login(email, password)

	})
}


/// logout function



if (logOutBtn) {

	logOutBtn.addEventListener('click', e => {

		e.preventDefault();

		logout();

	})
}




/// genre form submit


if (genreFormSubmit) {

	genreFormSubmit.addEventListener('submit', e => {

		e.preventDefault();

		const selectedGenres = Array.from(document.querySelectorAll('input[name="genres"]:checked'))
			.map(checkbox => checkbox.value);


		if (selectedGenres.length !== 2) {
			showAlert('error', 'Please select exactly two genres!');
			return;
		}

		const genresData = { genres: selectedGenres };

		updateSettings(genresData, 'data');

	})
}




document.addEventListener('DOMContentLoaded', () => {

	const ratingFormSubmit = document.querySelector('.form__ratings--form');


	/// Function to get the selected button's value for a specific rating group

	const getSelectedButtonValue = (groupName) => {

		const buttons = document.querySelectorAll(`button[name="${groupName}"]`);

		const selectedButton = Array.from(buttons).find(btn => btn.classList.contains('selected'));

		return selectedButton ? Number(selectedButton.value) : null;
	};

	if (ratingFormSubmit) {

		ratingFormSubmit.addEventListener('submit', e => {

			e.preventDefault();

			/// Create nested structure for form data using selected buttons

			const formDataObject = {
				graphics: {
					visuals: getSelectedButtonValue('visuals'),
					theme: getSelectedButtonValue('theme'),
					effects: getSelectedButtonValue('effects'),
					levelOfDetail: getSelectedButtonValue('levelOfDetail')
				},
				sound: {
					music: getSelectedButtonValue('music'),
					sEffects: getSelectedButtonValue('sEffects'),
					atmosphere: getSelectedButtonValue('atmosphere'),
					voiceActing: getSelectedButtonValue('voiceActing')
				},
				story: {
					plot: getSelectedButtonValue('plot'),
					characters: getSelectedButtonValue('characters'),
					emotion: getSelectedButtonValue('emotion'),
					originality: getSelectedButtonValue('originality')
				},
				gameplay: {
					mechanics: getSelectedButtonValue('mechanics'),
					challenge: getSelectedButtonValue('challenge'),
					pace: getSelectedButtonValue('pace'),
					lastability: getSelectedButtonValue('lastability')
				},
				bugs: {
					bugFree: getSelectedButtonValue('bugFree')
				},
				multiplayer: {
					online: getSelectedButtonValue('online')
				},
				genres: document.getElementById('form-genres').value,
				gameID: e.target.dataset.gameId,
				reviewID: e.target.dataset.reviewId,
				gameSlug: e.target.dataset.gameSlug
			};

			/// Optional: Add validation to ensure all ratings are selected

			const isValid = Object.values(formDataObject).every(category => {

				if (typeof category === 'object') {

					return Object.values(category).every(value => value !== null);
				}
				return true;
			});

			if (!isValid) {

				showAlert('error', 'Please select all Categories and sub categories!');

				return;
			}

			ratingForm(formDataObject);


		});

		// Button selection logic
		document.querySelectorAll('.rating__btn').forEach(button => {
			button.addEventListener('click', function () {
				// Find all buttons in the same parent group
				const parentGroup = this.closest('.rating__btn--block');
				const siblingButtons = parentGroup.querySelectorAll('.rating__btn');

				// Remove any previously selected buttons
				siblingButtons.forEach(btn => {
					btn.classList.remove('selected');
					btn.setAttribute('aria-selected', 'false');
				});

				// Select the current button
				this.classList.add('selected');
				this.setAttribute('aria-selected', 'true');
			});
		});
	}
});



//----------- Updating data -----------//


/// update current user data

if (updateDataForm) {

	updateDataForm.addEventListener('submit', event => {

		event.preventDefault();

		const form = new FormData();

		form.append('name', document.getElementById('user__form--name').value);
		form.append('email', document.getElementById('user__form--email').value);

		form.append('photo', document.getElementById('image-upload').files[0]);

		updateSettings(form, 'data');

	})
}


/// update current user password

if (updatePasswordForm) {

	updatePasswordForm.addEventListener('submit', event => {

		event.preventDefault();

		const passwordCurrent = document.getElementById('password-current').value;
		const password = document.getElementById('password').value;
		const passwordConfirm = document.getElementById('password-confirm').value;


		updateSettings({ passwordCurrent, password, passwordConfirm }, 'password');

	})
}






//-------------- Feedback Form ---------------//




const feedbackForm = document.getElementById('feedbackform');


if (feedbackForm) {

	feedbackForm.addEventListener('submit', function (e) {

		e.preventDefault();


		// const name = document.getElementById('name').value;
		// const email = document.getElementById('email').value;
		const feedback = document.getElementById('feedback').value;


		currentFeedback(feedback);


	})
}



//-------------- Steam link dot ------------------//


const steamDot = document.getElementById('steam_link-dot');

const baseText = 'Powered by Steam API';

let dotCount = 0;


const updateDots = () => {

	let dots = baseText;

	for (let i = 0; i < dotCount; i++) {


		dots += '.';
	}

	steamDot.textContent = dots;

	dotCount++;

	if (dotCount > 6) {

		dotCount = 0;
	}
}


if (steamDot) setInterval(updateDots, 800);




//-------------- Dynamic Account Page ------------------//


const userNav = document.getElementById('user__nav');

const accountMain = document.querySelector('.account__main');
const accountGenre = document.querySelector('.account__myGenres');
const accountRatings = document.querySelector('.account__myRatings');



if (userNav) {

	/// add the event listener to the whole navigation

	userNav.addEventListener('click', function (e) {

		e.preventDefault();

		const contentSections = [accountMain, accountGenre, accountRatings];

		function activateContent(activeSection) {

			contentSections.forEach(section => {

				if (section === activeSection) {

					section.classList.add('content__active');
					section.classList.remove('content__hidden');

				} else {

					section.classList.remove('content__active');
					section.classList.add('content__hidden');

				}
			});
		}

		if (e.target.classList.contains('nav__btn-settings')) {
			activateContent(accountMain);
		}
		if (e.target.classList.contains('nav__btn-genres')) {
			activateContent(accountGenre);
		}
		if (e.target.classList.contains('nav__btn-ratings')) {
			activateContent(accountRatings);
		}
	});

}



window.addEventListener('load', () => {

	const lazyImages = document.querySelectorAll('.game__img.lazy-steam');

	lazyImages.forEach(img => {
		const fullSrc = img.dataset.src;
		const realImg = new Image();
		realImg.src = fullSrc;
		realImg.onload = () => {
			img.src = fullSrc;
			img.classList.remove('lazy-steam');
			img.classList.add('loaded');
		};
	});
});






// document.addEventListener("DOMContentLoaded", () => {

// 	const hamburger = document.querySelector('.header--hamburger');

// 	const bottomMenu = document.querySelector('.header__bottom--list');

// 	console.log(hamburger);

// 	hamburger.addEventListener('click', (e) => {

// 		e.preventDefault();

// 		bottomMenu.classList.toggle('menu-visible');
// 	});
// });



document.addEventListener("DOMContentLoaded", () => {

	const hamburger = document.querySelector('.header--hamburger');

	const bottomMenu = document.querySelector('.header__bottom');

	const rightMenu = document.querySelector('.header__right');

	console.log(hamburger);

	hamburger.addEventListener('click', (e) => {

		e.preventDefault();

		bottomMenu.classList.toggle('menu-visible');
		rightMenu.classList.toggle('menu-visible');
	});
});



